import { ReactElement } from 'react';
import EmailSentPage from './views';

const EmailSentRoute = (): ReactElement => (
  <EmailSentPage />
);

export default EmailSentRoute;
